import { render, staticRenderFns } from "./DemographicsPanel.vue?vue&type=template&id=6b093d8c&scoped=true&"
import script from "./DemographicsPanel.vue?vue&type=script&lang=ts&"
export * from "./DemographicsPanel.vue?vue&type=script&lang=ts&"
import style0 from "./DemographicsPanel.vue?vue&type=style&index=0&id=6b093d8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b093d8c",
  null
  
)

export default component.exports
import {QSelect,QTabPanels,QTabPanel} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSelect,QTabPanels,QTabPanel})
